import React from "react";
import { Controller } from "react-hook-form";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const ControlledTextFieldSeparatedLabel = ({
	control,
	defaultValue,
	name,
	label,
	error,
	errorMessage,
	shrinkLabel = true,
	startAdornment,
	endAdornment,
	labelXs = 5,
	fieldXs = 7,
	...rest
}) => {
	return (
        <Controller
			control={control}
			name={name}
			defaultValue={defaultValue && defaultValue}
			render={({ field: { onChange, value } }) => (
				<Grid container columnSpacing={2} rowSpacing={0}>
					<Grid
                        sx={{
							display: "flex",
							alignItems: rest.multiline ? "start" : "center",
						}}
                        size={labelXs}>
						<Typography
							variant="label"
							component="label"
							htmlFor="bootstrap-input"
							// color={error && "error"}
							sx={{ mt: rest.multiline ? 0.4 : 0 }}
						>
							{label}:
						</Typography>
					</Grid>
					<Grid sx={{ display: "flex", alignItems: "center" }} size={fieldXs}>
						<TextField
                            id="bootstrap-input"
                            size="small"
                            value={value}
                            variant="outlined"
                            fullWidth
                            onChange={onChange}
                            error={error}
                            helperText={errorMessage ? errorMessage : ""}
                            {...rest}
                            slotProps={{
                                input: {
                                    startAdornment: startAdornment,
                                    endAdornment: endAdornment,
                                },

                                inputLabel: { shrink: shrinkLabel }
                            }} />
					</Grid>
				</Grid>
			)}
		></Controller>
    );
};

export default ControlledTextFieldSeparatedLabel;
